export default "__VITE_ASSET__fd37c12d__"